import * as React from 'react';
import { useState } from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    isWeb,
    SafeAreaView,
    ScrollView,
    Sheet,
    View,
    YStack,
} from 'smoothie';

import Employment from '../../../banking/components/kyc/steps/Employment';
import type { CustomerEdd } from '../../hooks/useCreateEdd';

interface UpdateEmploymentProps {
    isOpen: boolean;
    canBeDismissed: boolean;
    onClose: () => void;
    onContinue: () => void;
}

interface UpdateEmploymentModalProps {
    isOpen: boolean;
    canBeDismissed: boolean;
    onClose: () => void;
    onContinue: (customerEdd: CustomerEdd) => void;
}

export const UpdateEmploymentModal = ({
    onClose,
    canBeDismissed,
    isOpen,
    onContinue = () => {},
}: UpdateEmploymentModalProps) => {
    const [eddData, setEddData] = useState<CustomerEdd>();
    const enableSubmit =
        eddData?.employmentType != null && eddData?.occupationIndustry != null;

    return (
        <Sheet
            disableDrag
            isOpen={isOpen}
            onClose={onClose}
            dismissOnOverlayPress={canBeDismissed}
            showCloseButton={canBeDismissed}
        >
            <SafeAreaView>
                <ScrollView
                    paddingHorizontal={isWeb ? 8 : 0}
                    showsVerticalScrollIndicator={isWeb}
                    height={550}
                    $mobile_mini={{ height: 400 }}
                    $sm={{ height: '60vh' }}
                    outlineStyle="none" // not sure why, but sometimes this component loads with a focus outline
                >
                    <Employment
                        setKycData={({
                            employmentType,
                            occupationIndustry,
                        }) => {
                            if (
                                employmentType != null &&
                                occupationIndustry != null
                            ) {
                                setEddData({
                                    employmentType,
                                    occupationIndustry,
                                });
                            }
                        }}
                        kycData={eddData ?? {}}
                    />
                </ScrollView>
                <View
                    paddingTop={12}
                    backgroundColor="$white"
                    borderTopColor="$gray400"
                    borderTopWidth={1}
                >
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Confirm"
                        disabled={!enableSubmit}
                        onPress={() => {
                            if (eddData != null) {
                                onContinue({
                                    employmentType: eddData.employmentType,
                                    occupationIndustry:
                                        eddData.occupationIndustry,
                                });
                            }
                        }}
                    />
                </View>
            </SafeAreaView>
        </Sheet>
    );
};

export const UpdateEmployment = ({
    onClose,
    canBeDismissed,
    isOpen,
    onContinue = () => {},
}: UpdateEmploymentProps) => {
    return (
        <Sheet
            disableDrag
            isOpen={isOpen}
            onClose={onClose}
            dismissOnOverlayPress={canBeDismissed}
            showCloseButton={canBeDismissed}
            title="Update your employment status"
        >
            <SafeAreaView>
                <YStack
                    maxWidth={400}
                    alignSelf="center"
                    alignItems="center"
                    gap={16}
                    $sm={{ gap: 24 }}
                >
                    <BodyMediumRegular margin={16}>
                        As a Fruitful account holder, we&apos;re required to
                        gather information about your employment status.
                    </BodyMediumRegular>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Continue"
                        onPress={onContinue}
                    />
                </YStack>
            </SafeAreaView>
        </Sheet>
    );
};
